
import { 
  Users, 
  Shield,
  BarChartHorizontal,
  Package
} from "lucide-react";
import type { MenuItem } from "../types";

export const employeeSection: MenuItem = {
  title: "الموظفين",
  href: "#",
  icon: Users,
  color: "from-purple-500 to-purple-600",
  subItems: [
    {
      title: "قائمة الموظفين",
      href: "/employees",
      icon: Users,
      color: "from-purple-500 to-purple-600",
    },
    {
      title: "العهد",
      href: "/assets",
      icon: Package,
      color: "from-indigo-500 to-indigo-600",
      subItems: [
        {
          title: "إدارة العهد",
          href: "/assets",
          icon: Package,
          color: "from-indigo-500 to-indigo-600",
        },
        {
          title: "تصنيفات العهد",
          href: "/asset-categories",
          icon: Package,
          color: "from-indigo-500 to-indigo-600",
        },
        {
          title: "عهد الموظفين",
          href: "/employee-assets",
          icon: Package,
          color: "from-indigo-500 to-indigo-600",
        }
      ]
    },
    {
      title: "تحليلات الأداء",
      href: "/employee-analytics",
      icon: BarChartHorizontal,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "الصلاحيات",
      href: "/permissions",
      icon: Shield,
      color: "from-red-500 to-red-600",
    }
  ]
};
